import script from "./CatalogSortModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CatalogSortModal.vue?vue&type=script&lang=ts&setup=true"

import "./CatalogSortModal.vue?vue&type=style&index=0&id=5b35e4bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b35e4bb"]])

export default __exports__